import { Canvas } from '@react-three/fiber'
import { EffectComposer, Bloom } from '@react-three/postprocessing'
import { Suspense } from 'react'
import Scene from './Scene'

export default function App() {
  return (
    <Canvas camera={{ position: [0, 0, 4], fov: 70, near: 0.1, far: 100 }}>
      <color attach="background" args={['#050208']} />
      <Suspense fallback={null}>
        <Scene />
      </Suspense>
      <EffectComposer disableNormalPass>
        <Bloom luminanceThreshold={0} mipmapBlur luminanceSmoothing={0.1} intensity={1.8} />
      </EffectComposer>
    </Canvas>
  )
}
